// extracted by mini-css-extract-plugin
export var ContentWrapper = "style-module--ContentWrapper --36dde";
export var Heading = "style-module--Heading--2c002";
export var Section = "style-module--Section--1d871";